var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.3,
    height: 19.3,
    viewBox: "0 0 19.3 19.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".schedule_icon_1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.schedule_icon_2{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(835.7 -1266.6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "schedule_icon_1",
    d: "M-829.1,1269.5h-3.8a1.752,1.752,0,0,0-1.7,1.7v12a1.752,1.752,0,0,0,1.7,1.7h13.8a1.752,1.752,0,0,0,1.7-1.7v-12a1.752,1.752,0,0,0-1.7-1.7h-10Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "schedule_icon_2",
    cx: 0.9,
    cy: 0.9,
    r: 0.9,
    transform: "translate(-827 1276.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "schedule_icon_2",
    cx: 0.9,
    cy: 0.9,
    r: 0.9,
    transform: "translate(-822.4 1276.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "schedule_icon_2",
    cx: 0.9,
    cy: 0.9,
    r: 0.9,
    transform: "translate(-827 1280.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "schedule_icon_2",
    cx: 0.9,
    cy: 0.9,
    r: 0.9,
    transform: "translate(-822.4 1280.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "schedule_icon_2",
    cx: 0.9,
    cy: 0.9,
    r: 0.9,
    transform: "translate(-831.6 1276.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "schedule_icon_2",
    cx: 0.9,
    cy: 0.9,
    r: 0.9,
    transform: "translate(-831.6 1280.3)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "schedule_icon_1",
    x1: 17.2,
    transform: "translate(-834.7 1273.7)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "schedule_icon_1",
    y2: 1.7,
    transform: "translate(-831.2 1267.6)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "schedule_icon_1",
    y2: 1.7,
    transform: "translate(-821 1267.6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.65cd4588fb1d964dd2b26a1a11e0bf23.svg";
export { ForwardRef as ReactComponent };